import React, { useState, useEffect } from "react";
import flag_us from "../../assets/images/us_flag.png";
import flag_uk from "../../assets/images/uk_flag.png";
import flag_fr from "../../assets/images/fr_flag.png";
import flag_nl from "../../assets/images/dutch_flag.png";
import flag_it from "../../assets/images/it_flag.png";
import flag_de from "../../assets/images/de_flag.png";
import flag_pt from "../../assets/images/pt_flag.png";
import flag_ca from "../../assets/images/ca_flag.png";
import flag_sp from "../../assets/images/sp_flag.png";
import alertBox from "../../assets/images/alert_box.png";
import backArrow from "../../assets/images/back_arrow.png"
import { getSubs } from "../../services/getSubs";
import { GenerateButton } from "../generateButton";
import { ILanguagesProps } from "./languages.types";
import { split } from "../../utils/split";
import "../../styles/styles.scss";

export function Languages({
  getSubtitleData,
  maxLength,
  videoUrl,
  videoUrls,
  setShowLanguages,
  handleInvoke
}: ILanguagesProps) {
  const [audioUrl, setAudioUrl] = useState("");
  const [clicked, setClicked] = useState(false);
  const [language, setLanguage] = useState("");
  const [isLoading, setIsisLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [backToHome, setBackToHome] = useState(false);
  const [isError, setIsError] = useState(false);
  
  const handleBackButtonClick = () => {
    handleInvoke()
  };

  const handleFlagClick = (e: any) => {
    if (language === e.target.id) {
      setLanguage("");
      setSelected(null);
    } else {
      setLanguage(e.target.id);
      const id = e.target.id;
      setSelected(id);
    }
  };

  function delay(ms: any) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const displayErrorMessage = async() => {
    
    setIsError(true)
  await delay(2000);
  };

  const handleClick = async (e: any) => {
    e.preventDefault();

    try {
      setIsisLoading(true);
      const newTranscript = await getSubs(language, videoUrls);
      const data = [];
      for (const transcript of newTranscript) {
        if (typeof transcript === "string") {
          await displayErrorMessage()
          continue; // Skip further processing and move to the next iteration
        }
        if (transcript.transcript.words.length > 0) {
          const start = (transcript?.item?.startTime || 0)*100;
          const trim = transcript?.item?.start || 0;
          let sentence_array = split(transcript.transcript, start, trim,maxLength);
          data.push(...sentence_array);
        }
      }
      getSubtitleData(data);
      setBackToHome(true);
    } catch (error) {
      console.info(error);
      const alterDiv: any = document.getElementById("alert_message");
      alterDiv.style.display = "block";
      setTimeout(() => {
        alterDiv.style.display = "none";
        window.location.reload()
      }, 1500);
    }
  };

  useEffect(() => {
    let timer: any;
    if (isError === true) {
      const alterDiv: any = document.getElementById("alert_message");
      alterDiv.style.display = "block";
      timer = setTimeout(() => {
        alterDiv.style.display = "none";
        setIsError(false); // Reset the isError state after hiding the message
      }, 1500);
    }

    return () => clearTimeout(timer); // Clear the timer when the component unmounts or isError changes
  }, [isError]);

  useEffect(() => {
    if (backToHome === true) {
      //window.location.reload()
    }
  }, [backToHome]);

  return (
    <div>
      {
        isError && <div
        id="alert_message"
        style={{
          width: "350px",
          height: "35px",
          alignItems: "center",
          display: "none",
          zIndex: 999,
          marginTop: "20em",
          marginLeft: "0em",
          position: "absolute",
        }}
      >
        <div className="alert-container">
          <span
            style={{
              fontSize: "15px",
              fontWeight: "400",
              fontFamily: "Inter",
              color: "#FFFFFF",
              marginTop: "9px",
            }}
          >
            Failed to recognize any speech
          </span>
        </div>
        {/* <img src={alertBox} width='250px' height='35px' alt='Alert box'  style={{ filter: 'brightness(50%)' }}  /> */}
      </div> 
      }
      <div onClick={handleBackButtonClick} style={{ width: '30%', marginLeft: '-90%' }}>
        <img src={backArrow} height={19} width={16} />
      </div>
      <div style={{ width: '30%', marginTop: '-7%'}}>
        <span style={{ fontFamily: "Noto Sans", fontSize: '14px', fontWeight: '400', color: '#24282F' }}>Auto subtitle</span>
      </div>
        <span className="choose_language" style={{ fontFamily: "Noto Sans",fontWeight: '400',fontSize: '14px',color: '#24282F', position: 'absolute', marginTop: '10%', marginLeft: '-44%' }}>Choose language</span>
      <div className={"flags_container"} style={{ pointerEvents: isLoading ? 'none' : 'auto', opacity: isLoading ? 0.5 : ''}}>
        <div className="languages_container">
          <div className="flag_container" style={{ textAlign: "start" }}>
            <div
              className={`flag ${selected === "en_us" ? "selected" : ""}`}
              id="en_us"
              onClick={handleFlagClick}
              style={{
                border: selected === "en_us" ? "2px solid #3782F7" : "2px solid transparent",
                background : selected === "en_us" ? '#F0F6FF': '#F8F8F8',
                boxSizing: selected === "en_us" ? 'border-box' : 'border-box',
                padding: selected === "en_us" ? '2px': '2px',
              }}
            >
              <img
                style={{ marginTop: "5%", marginLeft: "20%" }}
                src={flag_us}
                id="en_us"
                alt="us_flag"
                height={25}
                width={24}
              />
              <span className="flag_name" id="en_us" style={{ marginLeft: '15%' }}>
                English
              </span>
            </div>
            <div
              className={`flag ${selected === "en_uk" ? "selected" : ""}`}
              id="en_uk"
              onClick={handleFlagClick}
              style={{
                border: selected === "en_uk" ? "2px solid #3782F7" : "2px solid transparent",
                background : selected === "en_uk" ? '#F0F6FF': '#F8F8F8',
                boxSizing: selected === "en_uk" ? 'border-box' : 'border-box',
                padding: selected === "en_uk" ? '2px': '2px'
              }}
            >
              <img
                style={{ marginTop: "5%", marginLeft: "20%" }}
                src={flag_uk}
                id="en_uk"
                alt="uk_flag"
                height={25}
                width={24}
              />
              <span className="flag_name" id="en_uk">
                English_UK
              </span>
            </div>
            <div
              className={`flag ${selected === "fr" ? "selected" : ""}`}
              id="fr"
              onClick={handleFlagClick}
              style={{
                border: selected === "fr" ? "2px solid #3782F7" : "2px solid transparent",
                background : selected === "fr" ? '#F0F6FF': '#F8F8F8',
                boxSizing: selected === "fr" ? 'border-box' : 'border-box',
                padding: selected === "fr" ? '2px': '2px'
              }}
            >
              <img
                style={{ marginTop: "5%", marginLeft: "20%" }}
                src={flag_fr}
                id="fr"
                alt="fr"
                height={25}
                width={24}
              />
              <span className="flag_name" style={{ marginLeft: "23%" }} id="fr">
                French
              </span>
            </div>
            <div
              className={`flag ${selected === "fr" ? "selected" : ""}`}
              id="nl"
              onClick={handleFlagClick}
              style={{
                border: selected === "nl" ? "2px solid #3782F7" : "2px solid transparent",
                background : selected === "nl" ? '#F0F6FF': '#F8F8F8',
                boxSizing: selected === "nl" ? 'border-box' : 'border-box',
                padding: selected === "nl" ? '2px': '2px'
              }}
            >
              <img
                style={{
                  marginTop: "5%",
                  mixBlendMode: "darken",
                  marginLeft: "20%",
                }}
                src={flag_nl}
                id="nl"
                alt="sk_flag"
                height={25}
                width={24}
              />
              <span className="flag_name" style={{ marginLeft: "20%" }} id="nl">
                Dutch
              </span>
            </div>
            {/* <div
              className={`flag ${selected === "fr_fr" ? "selected" : ""}`}
              id="fr_fr"
              onClick={handleFlagClick}
              style={{
                border: selected === "fr_fr" ? "2px solid #3782F7" : "none",
                background : selected === "fr_fr" ? '#F0F6FF': '#F8F8F8',
                boxSizing: selected === "fr_fr" ? 'border-box' : 'border-box',
                padding: selected === "fr_fr" ? '2px': '2px'
              }}
            >
              <img
                style={{ marginTop: "5%", marginLeft: "20%" }}
                src={flag_fr}
                id="fr_fr"
                alt="fr_flag"
                height={25}
                width={24}
              />
              <span
                className="flag_name"
                style={{ marginLeft: "15%" }}
                id="fr_fr"
              >
                French_Fr
              </span>
            </div> */}
            <div
              className={`flag ${selected === "it" ? "selected" : ""}`}
              id="it"
              onClick={handleFlagClick}
              style={{
                border: selected === "it" ? "2px solid #3782F7" : "2px solid transparent",
                background : selected === "it" ? '#F0F6FF': '#F8F8F8',
                boxSizing: selected === "it" ? 'border-box' : 'border-box',
                padding: selected === "it" ? '2px': '2px'
              }}
            >
              <img
                style={{ marginTop: "5%", marginLeft: "20%" }}
                src={flag_it}
                id="it"
                alt="it_flag"
                height={25}
                width={24}
              />
              <span className="flag_name" style={{ marginLeft: "23%" }} id="it">
                Italian
              </span>
            </div>
            <div
              className={`flag ${selected === "de" ? "selected" : ""}`}
              id="de"
              onClick={handleFlagClick}
              style={{
                border: selected === "de" ? "2px solid #3782F7" : "2px solid transparent",
                background : selected === "de" ? '#F0F6FF': '#F8F8F8',
                boxSizing: selected === "de" ? 'border-box' : 'border-box',
                padding: selected === "de" ? '2px': '2px'
              }}
            >
              <img
                style={{
                  marginTop: "5%",
                  mixBlendMode: "darken",
                  marginLeft: "20%",
                }}
                src={flag_de}
                id="de"
                alt="de_flag"
                height={25}
                width={24}
              />
              <span className="flag_name" style={{ marginLeft: "15%" }} id="de">
                German
              </span>
            </div>
            <div
              className={`flag ${selected === "es" ? "selected" : ""}`}
              id="es"
              onClick={handleFlagClick}
              style={{
                border: selected === "es" ? "2px solid #3782F7" : "2px solid transparent",
                background : selected === "es" ? '#F0F6FF': '#F8F8F8',
                boxSizing: selected === "es" ? 'border-box' : 'border-box',
                padding: selected === "es" ? '2px': '2px'
              }}
            >
              <img
                style={{
                  marginTop: "5%",
                  mixBlendMode: "darken",
                  marginLeft: "20%",
                }}
                src={flag_sp}
                id="es"
                alt="es_flag"
                height={25}
                width={24}
              />
              <span className="flag_name" style={{ marginLeft: "23%" }} id="es">
                Spanish
              </span>
            </div>
            <div
              className={`flag ${selected === "pt" ? "selected" : ""}`}
              id="pt"
              onClick={handleFlagClick}
              style={{
                border: selected === "pt" ? "2px solid #3782F7" : "2px solid transparent",
                background : selected === "pt" ? '#F0F6FF': '#F8F8F8',
                boxSizing: selected === "pt" ? 'border-box' : 'border-box',
                padding: selected === "pt" ? '2px': '2px'
              }}
            >
              <img
                style={{ marginTop: "5%", marginLeft: "20%" }}
                src={flag_pt}
                id="pt"
                alt="pt"
                height={25}
                width={24}
              />
              <span className="flag_name" id="pt">
                Portuguese
              </span>
            </div>
            <div
              className={`flag ${selected === "fr_ca" ? "selected" : ""}`}
              id="fr_ca"
              onClick={handleFlagClick}
              style={{
                border: selected === "fr_ca" ? "2px solid #3782F7" : "2px solid transparent",
                background : selected === "fr_ca" ? '#F0F6FF': '#F8F8F8',
                boxSizing: selected === "fr_ca" ? 'border-box' : 'border-box',
                padding: selected === "fr_ca" ? '2px': '2px'
              }}
            >
              <img
                style={{
                  marginTop: "5%",
                  mixBlendMode: "darken",
                  marginLeft: "20%",
                }}
                src={flag_ca}
                id="fr_ca"
                alt="fr_ca_flag"
                height={25}
                width={24}
              />
              <span className="flag_name" id="fr_ca">
                French-Ca
              </span>
            </div>
          </div>
        </div>
        <div style={{}} onClick={language === "" ? () => {} : handleClick}>
              <GenerateButton isLoading={isLoading} disabled={language} />
            </div>
      </div>
      
    </div>
  );
}